import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'

export const ItemGroupPopup = (props) => {
    return (
        <ModalBasic
            id="itemGroup"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Item group</span>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Item group no</label>
                        <TextInput type='number'
                            id='itemGroupNo' name='itemGroupNo'
                            value={props.itemObject.itemGroupNo}
                            handleChange={(event) => props.handleChange(event, 'itemGroupNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item group name</label>
                        <TextInput type='text'
                            id='itemGroupName' name='itemGroupName'
                            value={props.itemObject.itemGroupName}
                            handleChange={(event) => props.handleChange(event, 'itemGroupName')}
                            className={props.validState?.error?.itemGroupName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Item group description</label>
                        <TextInput type='text'
                            id='itemGroupDesc' name='itemGroupDesc'
                            value={props.itemObject.itemGroupDesc}
                            handleChange={(event) => props.handleChange(event, 'itemGroupDesc')}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChange(event, 'remarks')}
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}